<template>
  <Card class="card-user">
    <img slot="image" src="static/img/bg5.jpg" alt="...">
    <div class="author">
      <label for="avatar-input">
        <div class="background-image avatar">
          <div class="avatar-backdrop">
            <img src="static/img/photo-camera.png" class="backdrop-icon">
          </div>
        </div>
      </label>
      <input style="display:none" id="avatar-input" type="file" @change="readImage">
      <h5 class="title">{{user.nameToShow}}</h5>
      <p class="description">{{user.company}}</p>
    </div>
    <p class="description text-center">{{user.aboutToShow}}</p>

    <template slot="footer">
      <hr>
      <div class="button-container">
        <a
          :href="user.facebookProfile"
          target="_blank"
          class="btn btn-neutral btn-icon btn-round btn-lg"
          :title="getProfileText('facebook')"
        >
          <i class="fa fa-facebook-square"></i>
        </a>
        <a
          :href="user.twitterProfile"
          target="_blank"
          class="btn btn-neutral btn-icon btn-round btn-lg"
          :title="getProfileText('twitter')"
        >
          <i class="fa fa-twitter"></i>
        </a>
        <a
          :href="user.googlePlusProfile"
          target="_blank"
          class="btn btn-neutral btn-icon btn-round btn-lg"
          :title="getProfileText('google')"
        >
          <i class="fa fa-google-plus-square"></i>
        </a>
      </div>
    </template>
  </Card>
</template>
<script>
import Card from "src/components/UIComponents/Cards/Card.vue";
import helpers from "../../../../assets/config/helpers";
import sw from "sweetalert";

export default {
  components: { Card },
  props: ["user"],
  mounted() {
    this.setAvatar(this.user.profile_picture);
  },
  data() {
    return {
      details: [
        {
          title: "12",
          subTitle: "Files"
        },
        {
          title: "2GB",
          subTitle: "Used"
        },
        {
          title: "24,6$",
          subTitle: "Spent"
        }
      ]
    };
  },
  methods: {
    getClasses(index) {
      var remainder = index % 3;
      if (remainder === 0) {
        return "col-md-3 col-md-offset-1";
      } else if (remainder === 2) {
        return "col-md-4";
      } else {
        return "col-md-3";
      }
    },
    getProfileText(provider) {
      if (provider === "facebook") {
        return this.user.facebookProfile
          ? "Go to facebook profile"
          : "Please enter your profile";
      } else if (provider === "google") {
        return this.user.googlePlusProfile
          ? "Go to google profile"
          : "Please enter your profile";
      } else if (provider === "twitter") {
        return this.user.twitterProfile
          ? "Go to twitter profile"
          : "Please enter your profile";
      }
    },
    async readImage(e) {
      const file = document.querySelector("#avatar-input").files[0];

      try {
        const response = await helpers.fileToDataURL(file);
        const newData = { ...this.user, profile_picture: response };
        this.setAvatar(response);
        this.$emit("updateParent", newData, true);
      } catch (e) {
        swal("Error!", e.message, "error");
      }
    },
    setAvatar(image) {
      if (image) {
        const avatarEl = document.querySelector(".avatar");
        avatarEl.style.backgroundImage = `url('${image}')`;
      }
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/UserProfile/UserCard.vue